import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetCountryListQuery } from '../../../../store/api/companyapi'
import { useGetTaxcategoryQuery } from '../../../../store/api/customer'

const Tab1 = ({ formdata, handleChange, setFormData ,apidata }) => {
        const stateOptions =[
        { "name": "Andhra Pradesh" },
        { "name": "Arunachal Pradesh" },
        { "name": "Assam" },
        { "name": "Bihar" },
        { "name": "Chhattisgarh" },
        { "name": "Goa" },
        { "name": "Gujarat" },
        { "name": "Haryana" },
        { "name": "Himachal Pradesh" },
        { "name": "Jharkhand" },
        { "name": "Karnataka" },
        { "name": "Kerala" },
        { "name": "Madhya Pradesh" },
        { "name": "Maharashtra" },
        { "name": "Manipur" },
        { "name": "Meghalaya" },
        { "name": "Mizoram" },
        { "name": "Nagaland" },
        { "name": "Odisha" },
        { "name": "Punjab" },
        { "name": "Rajasthan" },
        { "name": "Sikkim" },
        { "name": "Tamil Nadu" },
        { "name": "Telangana" },
        { "name": "Tripura" },
        { "name": "Uttar Pradesh" },
        { "name": "Uttarakhand" },
        { "name": "West Bengal" },
        { "name": "Andaman and Nicobar Islands" },
        { "name": "Chandigarh" },
        { "name": "Dadra and Nagar Haveli and Daman and Diu" },
        { "name": "Delhi" },
        { "name": "Jammu and Kashmir" },
        { "name": "Ladakh" },
        { "name": "Lakshadweep" },
        { "name": "Puducherry" }
    ]

    const addrsstype = [{ "name": "Billing" }, { "name": "Shipping" }, { "name": "Office" }, { "name": "Personal" }, { "name": "Plant" }, { "name": "Postal" }, { "name": "Shop" }, { "name": "Subssidiary" }, { "name": "Warehouse" }, { "name": "Current" }, { "name": "Permananent" }, { "name": "Other" }]

    const [selectedCompany, setSelectedCompany] = useState('')
    const [isGroup, setIsGroup] = useState(0)
    const { data: countrydata, isLoading: countryLoader } = useGetCountryListQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery()

    return (
          <div>
                   <div className="px-3 py-4" style={{ background: 'white' }}>
                       <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
                       <div  className="col-md-12" style={{ display: 'flex' }} >
                           <div className="col-md-6 px-2">
                               <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                   <div style={{ display: 'flex', gap: '15px' }}>
                                       <div style={{ flex: 1 }}>
                                           <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Address Details</p>
                                       </div>
                                   </div>
                                   <div style={{ display: 'flex', gap: '15px' }}>
                                       <div style={{ flex: 1 }}>
       
                                           <Input
                                       name="addressTitle"
                                      value={apidata.name}
                                       label="Address Title"
                                       style={{ height: "30px" }} 
                                       readOnly
                                   />
                                       </div>
                                       <div style={{ flex: 1 }}>
                                          <Input
                                name="addressTitle"
                               value={apidata.address_type}
                                readOnly
                                
                                label="Customer Type"
                                style={{ height: "30px" }}
                            />
                                          
                                       </div>
                                       <div style={{ flex: 1 }}>
                                           <Input
                                       name="AddressLine1"
                                       value={apidata.address_line1}
                                       label="Address Line1"
                                       style={{ height: "30px" }}
                                       readOnly
                                   />
                                       </div>
                                   </div>
                                   <div style={{ display: 'flex', gap: '15px' }}>
                                       <div style={{ flex: 1 }}>
                                          <Input
                                       name="AddressLine2"
                                        value={apidata.address_line2}
                                       label="Address Line2"
                                       style={{ height: "30px" }}
                                       readOnly
                                   />
                                       </div>
       
                                       <div style={{ flex: 1 }}>
                                           <Input
                                name="addressTitle"
                                value={apidata.country}
                                readOnly
                                
                                label="County"
                                style={{ height: "30px" }}
                            />     
                                       </div>
       
       
                                       <div style={{ flex: 1 }}>
                                            <Input
                                name="addressTitle"
                                value={apidata.state}
                                readOnly
                                
                                label="State/Province"
                                style={{ height: "30px" }}
                            />
                                       </div>
       
       
                                   </div>
       
                               </div>
                           </div>
       
                           <div className="col-md-6 px-2">
                               <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                   <div style={{ display: 'flex', gap: '15px' }}>
                                       <div style={{ flex: 1, height:'22px' }}>
                                           <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}></p>
                                       </div>
                                   </div>
                                   <div style={{ display: 'flex', gap: '15px' }}>
       
       
                                       <div style={{ flex: 1 }}>
                                          <Input
                                name='City'
                                readOnly
                                label="City/Town"
                                value={apidata.city}
                                
                                style={{ height: "30px" }}
                            />
                                       </div>
       
                                       <div style={{ flex: 1 }}>
       
                                           <Input
                                name='postalCode'
                                readOnly
                                label="Postal Code"
                                value={apidata.pincode}
                               
                                style={{ height: "30px" }}
                            />
                                       </div>
                                       <div style={{ flex: 1 }}>
                                          <Input
                                label="Email Address"
                                readOnly
                                name='email'
                                value={apidata.email_id}
                                style={{ height: "30px" }}
                            />
                                       </div>
                                   </div>
                                   <div style={{ display: 'flex', gap: '15px' }}>
       
                                       <div style={{ flex: 1 }}>
                                           
                                          <Input
                                label="Phone"
                                readOnly
                                name='Phone'
                                value={apidata.phone}
                                style={{ height: "30px" }}
                            />
       
       
                                       </div>
                                       <div style={{ flex: 1 }}>
                                           <Input
                            readOnly
                                name='Fax'
                                label="Fax"
                                value={apidata.fax}
                                style={{ height: "30px" }}
                            />
                                       </div>
        <div style={{ flex: 1 }}>
                                           <Input
                                name="addressTitle"
                                 value={apidata.tax_category}
                                readOnly
                                
                                label="Tax Category"
                                style={{ height: "30px" }}
                            />
       
                                       </div>
                                      
       
                                   </div>
        <div style={{ display: 'flex', gap: '15px' }}>
       
                                       <div style={{ flex: 1 }}>
                                           {/* <label style={{ height: '19px' }}></label> */}
                                           <Checkbox
                                               id="PreferredBillingAddress"
                                               label="Preferred Billing Address"
                                               checked={true}
                                               value={apidata.is_primary_address===1}
                                             disabled={true}
                                           />
       
                                       </div>
                                       <div style={{ flex: 1 }}>
                                            {/* <label style={{ height: '19px' }}></label> */}
                                           <Checkbox
                                               id="PreferredShippingAddress"
                                               label="Preferred Shipping Address"
                                               checked={true}
                                               value={apidata.is_shipping_address === 1 }
                                               disabled={true}
                                           />
                                       </div>
        <div style={{ flex: 1 }}>
                                           {/* <label style={{ height: '19px' }}></label> */}
                                           <Checkbox
                                               id="Disabled"
                                               label="Disabled"
                                               checked={true}
                                               value={apidata.disabled===1}
                                              disabled={true}
                                           />
       
                                       </div>
                                      
       
                                   </div>
       
       
       
                               </div>
                           </div>
                       </div>
                   </div>
                 
                 
               </div>
       
               </div>
    )
}

export default Tab1